export default __webpack_public_path__ + "resources/icons/d431-c30b.png";